const defaultState = {};

export default function UserReducer(state = defaultState, action) {
  switch (action.type) {
    default:
      return state;
  }
}
